import { FormikProps } from "formik";
import { OpretFirmaStep1Formik } from "../../opretFirmaInterface";
import { TextInputFormik } from "../../../../formcontrols/InputItem";
import { SelectFormik } from "../../../../formcontrols/Select";
import { AddressGenericFormSet } from "../../../../formcontrols/sets/AddressGenericFormSet";
import { useKodeListe } from "../../../../../hooks/useQueries";

const OpretFirmaFO = ({
  formik,
}: {
  formik: FormikProps<OpretFirmaStep1Formik>;
}) => {
  const { getKodelisteError, getKodelisteIsLoading, kodeliste } = useKodeListe(
    "VirksomhedsformKode",
  );

  if (getKodelisteError) return <div>Fejl</div>;
  if (getKodelisteIsLoading) return <div>Henter koder ...</div>;
  if (!kodeliste) return null;
  const labelData: LabelValueType[] = (kodeliste as KodeListeEnumType[]).map(
    (virksomhedsform) => {
      return {
        label: virksomhedsform.navn,
        value: virksomhedsform.id,
      };
    },
  );
  return (
    <>
      <div className="w-100">
        <TextInputFormik
          config={{
            component: "textinput",
            id: "navn",
            initialValue: "",
            label: "Firmanavn",
            isRequired: true,
            placeholder: "Indtast firmanavn",
          }}
          formik={formik}
        />
      </div>
      <div className="w-100">
        <TextInputFormik
          config={{
            component: "textinput",
            id: "udenlandskCvr",
            initialValue: "",
            label: "Færøsk CVR nummer?",
            placeholder: "Indtast cvr-nr",
          }}
          formik={formik}
        />
      </div>
      <div className="w-100 position-relative">
        <SelectFormik
          config={{
            component: "select",
            id: "virksomhedsform",
            label: "Virksomhedsform",
            isRequired: true,
            placeholder: "Vælg ...",
          }}
          formik={formik}
          data={labelData}
        />
      </div>
      <AddressGenericFormSet formik={formik} hasLandekode={false} />
    </>
  );
};

export default OpretFirmaFO;
